import routes from './routes';
import { SetRoutes } from 'components';

const InvoicesSalesTrendsPages = () => {
  return (
    <>
      <SetRoutes routes={routes} />
    </>
  );
};

export default InvoicesSalesTrendsPages;
